'use client';
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import V3HeroSection from './components/V3HeroSection';
import AutoGeneratePanel from './components/AutoGeneratePanel';
import PricingSection from './components/PricingSection';
import AIChatWidget from '@/components/AIChatWidget';

export default function HomePage() {
  return (
    <main style={{ background: 'var(--blackout)', minHeight: '100vh' }}>
      <Header />
      <V3HeroSection />
      <AutoGeneratePanel />
      <PricingSection />
      <Footer />
      <AIChatWidget />
    </main>
  );
}